import { render, staticRenderFns } from "./TestPackage.vue?vue&type=template&id=2aaa83a4"
import script from "./TestPackage.vue?vue&type=script&lang=js"
export * from "./TestPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports